import { cva } from 'cva'

export const badgeV1Variants = cva({
  base: ['inline-flex items-center text-xs font-bold rounded text-white h-6 px-2'],
  variants: {
    variant: {
      default: 'bg-gray-500',
      primary: 'bg-primary',
      blue: 'bg-blue-normal',
      expire: 'bg-gray-200 text-gray-400',
      error: 'bg-red-normal',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})
